import React from 'react'
import ListInventoryBody from '../../inventory/list/ListInventoryBody'
import { subscriptionHistory } from '../../../state'
import { Table } from '../../common/Table/TableBody'

interface SubscriptionHistoryProps {
  history: subscriptionHistory[];
  isLoading:boolean;
}

const SubscriptionHistory = ({ history, isLoading }: SubscriptionHistoryProps) => {

  const renderSubscriptionTableHead = () => {
    return {
      name: { title: ' ITEM NAME' },
      startDate: { title: 'START DATE' },
      endDate: { title: 'END DATE' },
      amount: { title: 'AMOUNT' },
    };
  };

  const renderSubscriptionHistoryData = () => {
  return history?.map((item:any) => {
      return {
        name: item.plan,
        startDate: item.startDate ? item.startDate : "N/A",
        endDate: item.endDate ? item.endDate: "N/A",
        amount: item.costPerMonth,
      }
  })

  }

  return (
    <div>
        <Table
          head={renderSubscriptionTableHead()}
         data={renderSubscriptionHistoryData()}
         isLoading={isLoading}
        />
    </div>
  )
}

export default SubscriptionHistory